import React, { ReactNode, useEffect } from 'react';
import { ToastContext, useToastState } from '../../hooks/useToast';
import { globalToastService } from '../../services/globalToastService';

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const toastState = useToastState();

  // Register the toast callback with the global service
  useEffect(() => {
    globalToastService.registerToastCallback(toastState.showToast);
    
    // Cleanup on unmount
    return () => {
      globalToastService.unregisterToastCallback(toastState.showToast);
    };
  }, [toastState.showToast]);

  return (
    <ToastContext.Provider value={toastState}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider; 